module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.448c34a56d699c29117a.woff2";


//////////////////
// WEBPACK FOOTER
// G:/UTL/Student/Student-ANG/src/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2
// module id = ../../../../../src/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2
// module chunks = styles